import { useContext } from 'react';

import InputDateRange from '@atom/components/common/inputDateRange/InputDateRange';
import {
  convertRangeDateToMillis,
  DateRangePresetOption,
  DateRangeTerminator,
} from '@atom/utilities/workOrdersDateFilterUtilities';

import WorkOrdersFiltersContext, {
  FilterForm,
} from './WorkOrdersFiltersContext';

import classes from './filters.module.css';

type FilterDateRangeProps = {
  label: string;
  presetField: keyof FilterForm;
  startField: keyof FilterForm;
  endField: keyof FilterForm;
};

const FilterDateRange = ({
  label,
  presetField,
  startField,
  endField,
}: FilterDateRangeProps) => {
  const { filterForm, areFiltersDisabled, updateFilterForm } = useContext(
    WorkOrdersFiltersContext,
  );

  const startMillis = filterForm[startField] as number;
  const endMillis = filterForm[endField] as number;

  return (
    <div className={classes.filterContainer}>
      <InputDateRange
        label={label}
        disabled={areFiltersDisabled}
        presetSelected={filterForm[presetField] as string}
        handleSelectDatePreset={(option: DateRangePresetOption) =>
          updateFilterForm(presetField, option.value)
        }
        startDateValue={startMillis ? new Date(startMillis) : null}
        handleStartChange={(dateValue: Date) =>
          updateFilterForm(
            startField,
            convertRangeDateToMillis(
              dateValue,
              DateRangeTerminator.START,
              filterForm[presetField] as string,
            ),
          )
        }
        endDateValue={endMillis ? new Date(endMillis) : null}
        handleEndChange={(dateValue: Date) =>
          updateFilterForm(
            endField,
            convertRangeDateToMillis(
              dateValue,
              DateRangeTerminator.END,
              filterForm[presetField] as string,
            ),
          )
        }
      />
    </div>
  );
};

export default FilterDateRange;
